import React from 'react';

/**
 * Role vocabulary selector (T10.2). Frontend roles only — the spec's
 * snake_case roles are normalized at auth-integration time
 * (docs/skill/auth-permissions.md). Reused by the invite form.
 */
function RoleSelector({ id, value, onChange, disabled }) {
  return (
    <select
      aria-label="Role"
      disabled={disabled}
      id={id}
      onChange={(event) => onChange(event.target.value)}
      value={value}
    >
      <option value="agency-admin">agency-admin — full control incl. billing &amp; settings</option>
      <option value="operator">operator — approvals and agent changes</option>
      <option value="viewer">viewer — read-only observability</option>
    </select>
  );
}

export default RoleSelector;
